export default __webpack_public_path__ + "static/media/slide-2.3b66fad1.svg";